var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChurchOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:church-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.83398 64.166V40.8327L17.5007 35.6556V26.2493L32.084 18.9577V14.5827H26.2507V8.74935H32.084V2.91602H37.9173V8.74935H43.7507V14.5827H37.9173V18.9577L52.5007 26.2493V35.6556L64.1673 40.8327V64.166H37.9173V52.4993C37.9173 51.673 37.6373 50.9798 37.0773 50.4198C36.5173 49.8598 35.8251 49.5807 35.0007 49.5827C34.1743 49.5827 33.4811 49.8627 32.9211 50.4227C32.3611 50.9827 32.082 51.6749 32.084 52.4993V64.166H5.83398ZM11.6673 58.3327H26.2507V52.3535C26.2507 49.8743 27.1013 47.7714 28.8027 46.0448C30.5041 44.3181 32.5701 43.4557 35.0007 43.4577C37.4312 43.4577 39.4972 44.321 41.1986 46.0477C42.9 47.7743 43.7507 49.8763 43.7507 52.3535V58.3327H58.334V44.3327L46.6673 39.0827V29.3118L35.0007 23.3327L23.334 29.3118V39.0827L11.6673 44.3327V58.3327ZM35.0007 39.3743C36.2159 39.3743 37.2494 38.9485 38.1011 38.0968C38.9527 37.2452 39.3776 36.2127 39.3757 34.9993C39.3757 33.7841 38.9498 32.7506 38.0982 31.8989C37.2465 31.0473 36.214 30.6224 35.0007 30.6243C33.7854 30.6243 32.7519 31.0502 31.9002 31.9018C31.0486 32.7535 30.6237 33.786 30.6257 34.9993C30.6257 36.2146 31.0515 37.2481 31.9032 38.0998C32.7548 38.9514 33.7873 39.3763 35.0007 39.3743Z",
    fill: "#0079FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurchOutline);
export default __webpack_public_path__ + "static/media/church_outline.28ad3930d184fb698431451229b337e8.svg";
export { ForwardRef as ReactComponent };